import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRocket12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconRocket12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Rocket12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M6.764 1.906c.98-.98 2.607-1.067 3.832-.93.24.027.412.2.44.439.136 1.225.05 2.851-.931 3.832A15.9 15.9 0 0 1 5.282 8.52l-1.79-1.79a15.9 15.9 0 0 1 3.273-4.823m4.048 4.048c-.508.508-1.028.957-1.538 1.35v2.047a.5.5 0 0 1-.229.42l-3.029 1.953c-.772.498-1.75-.22-1.506-1.106l.314-1.141-2.29-2.29-1.14.314C.507 7.745-.21 6.767.286 5.995L2.24 2.966a.5.5 0 0 1 .42-.23H4.7l.007.001c.394-.51.843-1.03 1.351-1.538 1.33-1.33 3.384-1.358 4.65-1.217a1.48 1.48 0 0 1 1.322 1.322c.141 1.266.113 3.32-1.217 4.65M5.878 9.35a17 17 0 0 0 2.396-1.33v1.057l-2.8 1.806.386-1.4a.5.5 0 0 0 .018-.134M3.99 3.737H2.933l-1.805 2.8 1.4-.386a.5.5 0 0 1 .133-.018c.267-.591.698-1.446 1.329-2.396m4.105.179a.96.96 0 1 0 1.36-1.359.96.96 0 0 0-1.36 1.359"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Rocket12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconRocket12);
